import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { matchPath, useLocation } from 'react-router-dom';

import { mobigestorRoutes as routes } from 'config/routes';

import VideoCallProvider from 'socketContext/VideoCallProvider';
import { AccessUnavaliable } from 'components/molecules/AccessUnavaliable';

import DashList from './components/DashList';
import Content from './components/Content';
import Header from './components/Header';

const mobigestorRoutes = routes;

function Container(props) {
  const [state, setState] = useState({
    open: false,
    isInCallCenterPage: false,
    hiddeMenuAndHeaderItens: false,
  });

  const { currentDealer } = useSelector(state => state.dealerStore);
  const { restrictAccess } = useSelector(state => state.userStore);

  const handleDrawerOpen = () => {
    setState(prevState => ({ ...prevState, open: true }));
  };

  const handleDrawerClose = () => {
    setState(prevState => ({ ...prevState, open: false }));
  };

  const location = useLocation();

  const checkPathNameToHiddeElements = () => {
    const currentRoute =
      mobigestorRoutes.routes &&
      mobigestorRoutes.routes.find(route =>
        matchPath(location.pathname, route)
      );
    setState(prevState => ({
      ...prevState,
      hiddeMenuAndHeaderItens: currentRoute?.data?.hiddeMenuAndHeaderItens,
      groupTitle: currentRoute?.data?.groupTitle,
    }));
  };

  useEffect(() => {
    checkPathNameToHiddeElements();
  }, [location]);

  const {
    children,
    isConsultantUser,
    isWithoutDealer,
    dealerStore: { logo },
  } = props;

  const hiddenMenuAndHeader = restrictAccess || state.hiddeMenuAndHeaderItens;

  return (
    <div
      style={{
        display: 'flex',
        minHeight: '100vh',
        width: '100%',
      }}
    >
      <Header
        {...props}
        open={state.open}
        icons={props.icons}
        logo={logo}
        showCallCenterTitle={state.isInCallCenterPage}
        hiddeMenuAndHeaderItens={hiddenMenuAndHeader}
        groupTitle={state.groupTitle}
        isConsultantUser={isConsultantUser}
        isWithoutDealer={isWithoutDealer}
        handleDrawerOpen={handleDrawerOpen}
        handleDrawerClose={handleDrawerClose}
      />

      {props.reRenderMenu ? (
        <DashList
          {...props}
          open={state.open}
          handleDrawerOpen={handleDrawerOpen}
          handleDrawerClose={handleDrawerClose}
          hiddeMenuAndHeaderItens={hiddenMenuAndHeader}
          isWithoutDealer={isWithoutDealer}
          location={location}
        />
      ) : (
        <div style={{ width: 251, height: '100vh' }}></div>
      )}

      <Content currentDealer={currentDealer} menuOpened={state.open}>
        <AccessUnavaliable>{children}</AccessUnavaliable>
      </Content>
      <VideoCallProvider
        hiddeMenuAndHeaderItens={state.hiddeMenuAndHeaderItens}
      />
    </div>
  );
}

export default Container;
